var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:{
    'success': _vm.type === 'success',
    'warning': _vm.type === 'warning',
    'error': _vm.type === 'error',
    'info': _vm.type === 'info',
    'light': _vm.type === 'light'
  }},[(_vm.icon)?_c('div',{staticClass:"icon"},[_c('fa-icon',{attrs:{"icon":_vm.icon,"size":"1x","spin":_vm.icon[1] === 'spinner'}})],1):_vm._e(),_c('div',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }